import React from 'react';
import '../styles/history.css'; 


const Modal = ({ onClose, history, play }) => {
  // Parse the history prop
  const historySplit = history?.split(';');

  const data = historySplit?.map((item) => {
    const itemSplit = item.split(',');
    const [day, month, year] = itemSplit[1].split(' ')[0].split('/');
    const [hour, minute] = itemSplit[1].split(' ')[1].split(':');


    return {
      matchId: itemSplit[0],
      date: `${day}/${month}/${year} ${hour}:${minute}`,
      team1Id: itemSplit[2],
      teamName1: itemSplit[3],
      team2Id: itemSplit[4],
      teamName2: itemSplit[5],
      teamHand: itemSplit[6],
      tmWLDA: itemSplit[7],
      score: `${itemSplit[8]}-${itemSplit[9]}`,
      score1: `${itemSplit[10]}-${itemSplit[11]}`,
      win: itemSplit[12],
    };
  });

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h5>History Details</h5>
          <button className="close-button" onClick={onClose}>
            <span className='clode-btn-label'>&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>Date Time</th>
                  <th>Match</th>
                  {play === 'soccer' && <th>HT Score</th>}
                  <th>Score</th>
                  <th>Stat</th>
                </tr>
              </thead>
              <tbody>
                {data.map((match) => (
                  <tr key={match.matchId}>
                    <td>{match.date}</td>
                    <td>
                      {match.teamName1} <span>vs</span> {match.teamName2}
                    </td>
                    <td>{match.score}</td>
                    {play === 'soccer' && <td>{match.score1}</td>}
                    <td>
                      {match.tmWLDA === 'W' && (
                        <span className="badge win">W</span>
                      )}
                      {match.tmWLDA === 'L' && (
                        <span className="badge lose">L</span>
                      )}
                      {match.tmWLDA === 'D' && (
                        <span className="badge draw">D</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
